export const CONTENT_BLOCK_FEATURE_KEY = 'contentBlock';
